import { Date, Image, Link } from '@utils/cook/types'

export interface DateTime {
  date: string
  time: string
  dateOrTime: string
  sameDateTime: string | null
}

export type FormattedDateTime = DateTime | '' | Record<string, unknown>

export interface HeadlineHeroImage extends Image<'1_1' | '3_4'> {
  credit: { text: string; link: Link }
}

export type CommonHeadlineLeadAPIProps = {
  title: string
  catchword: string
  lead: string
  displayCommentsOnArticle: boolean
  publishedDate: Date
  updatedDate: Date
}

export type NormalHeadlineLeadAPIProps = CommonHeadlineLeadAPIProps

export type HerotellingHeadlineLeadAPIProps = CommonHeadlineLeadAPIProps & {
  storytellingImage: HeadlineHeroImage
}

export type HeadlineLeadAPIProps =
  | NormalHeadlineLeadAPIProps
  | HerotellingHeadlineLeadAPIProps

const isInHerotellingPageHeadlineLeadAPIProps = (
  _props: any,
  isInHerotellingPage: boolean,
): _props is HerotellingHeadlineLeadAPIProps => isInHerotellingPage

export { isInHerotellingPageHeadlineLeadAPIProps }
